import React from 'react';
import { useOffersFilterContextProvider } from './filter-context';
import { Offers } from './Offers';
export function OffersContainer() {
    const { value: OffersFilterValue, OffersFilterContextProvider } = useOffersFilterContextProvider();
    return (React.createElement(OffersFilterContextProvider, { value: OffersFilterValue },
        React.createElement(Offers, null)));
}
